var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiveIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(-180 12 12)",
    fill: "#3394F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5C12.56 5 13 4.55 13 4V3C13 2.45 12.55 2 12 2C11.45 2 11 2.45 11 3V4C11 4.55 11.45 5 12 5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0102 6.91001L18.7202 6.20001C19.1102 5.81001 19.1102 5.18001 18.7202 4.79001C18.3302 4.40001 17.7002 4.40001 17.3102 4.79001L16.6002 5.50001C16.2102 5.89001 16.2102 6.52001 16.6002 6.91001C16.9802 7.29001 17.6202 7.29001 18.0102 6.91001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19 12.55 19.45 13 20 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H20C19.45 11 19 11.45 19 12Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13H4C4.55 13 5 12.55 5 12C5 11.45 4.55 11 4 11H3C2.45 11 2 11.45 2 12C2 12.55 2.45 13 3 13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98988 6.91001C6.37988 7.30001 7.00988 7.30001 7.39988 6.91001C7.78988 6.52001 7.78988 5.89001 7.39988 5.50001L6.68988 4.79002C6.29988 4.40002 5.66988 4.40002 5.27988 4.79002C4.88988 5.18002 4.88988 5.81002 5.27988 6.20002L5.98988 6.91001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00005 15.98V19C9.00005 20.1 9.90005 21 11 21H13C14.1 21 15 20.1 15 19V15.98C16.43 14.9 17.28 13.08 16.91 11.07C16.55 9.12 15.01 7.52 13.07 7.12C9.84005 6.44 7.00005 8.89 7.00005 12C7.00005 13.63 7.79005 15.06 9.00005 15.98ZM11 16.9C11.32 16.96 11.66 17 12 17C12.34 17 12.68 16.96 13 16.9V19H11V16.9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveIdea);
export default __webpack_public_path__ + "static/media/give_idea.7faae248fa9eb5409e99ae2e95072770.svg";
export { ForwardRef as ReactComponent };